// mantine
import { Menu } from '@mantine/core';
// icons
import { Check } from 'lucide-react';
// utils
import { cn } from '@/utils';

interface DrawMenuItemProps {
    icon: React.ReactNode;
    children: React.ReactNode;
    isSelected: boolean;
    onClick: () => void;
}
const DrawerMenuItem = ({
    icon,
    children,
    isSelected,
    onClick
}: DrawMenuItemProps) => (
    <Menu.Item
        leftSection={
            <Check
                className={cn('opacity-0', {
                    'opacity-100': isSelected
                })}
            />
        }
        rightSection={<span className="text-gray-5">{icon}</span>}
        onClick={onClick}
    >
        {children}
    </Menu.Item>
);

export default DrawerMenuItem;
